import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoaPaymentDetailsComponentActions = createActionGroup({
  source: 'POA Payment Details Component',
  events: {
    'Sign In Banner Dismissed': emptyProps(),
    'Email Verification Pending Popup Closed': emptyProps(),
    'Continue As Guest Clicked': emptyProps(),
    'Sign In Banner Signed In': props<{ username: string }>(),
    'Sign In Resend Link': emptyProps(),
    'Sign In Change Username': emptyProps(),
  },
});
